import { IResponseData } from '@/core/interfaces/common'
import { WalletWithdrawalModel } from '@/modules/Profile/Wallets/models/WalletsModel'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
  IChatsWalletRequest,
  IChatsWalletResponse,
  Wallet,
  WalletOperationRequest,
  WalletOperationResponse,
  WalletPage,
  WalletReceive,
  WalletWithdrawalResponse,
} from './WalletInterface'
import WalletService from './WalletService'

interface WalletState {
  wallets: Wallet[]
  wallet: WalletPage | null
  receive: WalletReceive | null
  transactions: IResponseData<WalletOperationResponse[]> | null
  withdrawal: WalletWithdrawalResponse | null
  chats: IChatsWalletResponse | null
}

const initialState: WalletState = {
  wallets: [],
  wallet: null,
  receive: null,
  transactions: null,
  withdrawal: null,
  chats: null,
}
export const getWalletsThunk = createAsyncThunk(
  'wallet/getWalletsThunk',
  async (_, { rejectWithValue }) => {
    try {
      return await WalletService.getWallets()
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getWalletThunk = createAsyncThunk(
  'wallet/getWalletThunk',
  async (code: string, { rejectWithValue }) => {
    try {
      return await WalletService.getWallet(code)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getWalletWithdrawalThunk = createAsyncThunk(
  'wallet/getWalletWithdrawalThunk',
  async (code: string, { rejectWithValue }) => {
    try {
      return await WalletService.getWalletWithdrawal(code)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getWalletReceiveThunk = createAsyncThunk(
  'wallet/getWalletReceiveThunk',
  async (code: string, { rejectWithValue }) => {
    try {
      return await WalletService.getWalletReceive(code)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getWalletOperationsThunk = createAsyncThunk(
  'wallet/getWalletOperationsThunk',
  async (data: WalletOperationRequest, { rejectWithValue }) => {
    try {
      return await WalletService.getWalletOperations(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const withdrawalThunk = createAsyncThunk(
  'wallet/withdrawalThunk',
  async (data: WalletWithdrawalModel, { rejectWithValue }) => {
    try {
      return await WalletService.withdrawal(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getChatsWalletThunk = createAsyncThunk(
  'wallet/getChatsWalletThunk',
  async (data: IChatsWalletRequest, { rejectWithValue }) => {
    try {
      return await WalletService.getChatsWallet(data)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {},

  extraReducers: builder => {
    builder

      .addCase(getWalletsThunk.fulfilled, (state, action) => {
        state.wallets = action.payload
      })
      .addCase(getWalletsThunk.rejected, state => {
        state.wallets = []
      })

      .addCase(getWalletThunk.fulfilled, (state, action) => {
        state.wallet = action.payload
      })
      .addCase(getWalletThunk.rejected, state => {
        state.wallet = null
      })

      .addCase(getWalletReceiveThunk.fulfilled, (state, action) => {
        state.receive = action.payload
      })
      .addCase(getWalletReceiveThunk.rejected, state => {
        state.receive = null
      })

      .addCase(getWalletOperationsThunk.fulfilled, (state, action) => {
        state.transactions = action.payload
      })
      .addCase(getWalletOperationsThunk.rejected, state => {
        state.transactions = null
      })

      .addCase(getWalletWithdrawalThunk.fulfilled, (state, action) => {
        state.withdrawal = action.payload
      })
      .addCase(getWalletWithdrawalThunk.rejected, state => {
        state.withdrawal = null
      })

      .addCase(getChatsWalletThunk.fulfilled, (state, action) => {
        state.chats = action.payload
      })
      .addCase(getChatsWalletThunk.rejected, state => {
        state.chats = null
      })
  },
})

export const { actions, reducer } = walletSlice
